import React from "react";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal } from "react-bootstrap";
const HelpTextModal = ({ showModalHelp, setShowModalHelp, text }) => {
  const handleCloseShowModal = () => {
    setShowModalHelp(false);
  };
  return (
    <Modal centered show={showModalHelp} onHide={handleCloseShowModal}>
      <Modal.Header closeButton>
        <Modal.Title>اطلاعات بیشتر</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ lineHeight: "2rem" }}>{text}</Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleCloseShowModal}>
          <CloseIcon />
          بستن
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default HelpTextModal;
